import { Component, inject } from '@angular/core';
import { PaSelectComponent } from '../../../../shared/ui-kit/pa-select/pa-select.component';
import { FormBuilder, FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { PaMultiSelectComponent } from 'src/app/shared/ui-kit/pa-multi-select/pa-multi-select.component';
import { DictionaryDTO } from 'src/app/core/models/dictionary';
import { PaAutocompleteComponent } from 'src/app/shared/ui-kit/pa-autocomplete/pa-autocomplete.component';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';

@Component({
  selector: 'app-select-view',
  templateUrl: './select-view.component.html',
  styleUrls: ['./select-view.component.scss'],
  imports: [
    PaSelectComponent,
    FormsModule,
    ReactiveFormsModule,
    PaMultiSelectComponent,
    PaAutocompleteComponent,
  ],
  standalone: true,
})
export class SelectViewComponent {
  private fb = inject(FormBuilder);

  cities: DictionaryDTO[] = [
    { name: 'Нью-Йорк', id: 'NY' },
    { name: 'Очень длинное название города 22', id: 'LONG_NAME' },
    { name: 'Рим', id: 'RM' },
    { name: 'Лондон', id: 'LDN' },
    { name: 'Стамбул', id: 'IST' },
    { name: 'Париж', id: 'PRS' },
  ];

  form = this.fb.group({
    counter: new FormControl(),
  });

  form2 = this.fb.group({
    counter: new FormControl({ value: 'LDN', disabled: true }),
  });

  form2Multi = this.fb.group({
    counter: new FormControl({ value: ['NY', 'RM'], disabled: true }),
  });

  form3 = this.fb.group({
    counter: new FormControl('', Validators.required),
  });

  form4 = this.fb.group({
    city: new FormControl(),
  });

  form5 = this.fb.group({
    cities: new FormControl([], Validators.required),
  });

  form6 = this.fb.group({
    cities: new FormControl([], Validators.required),
  });

  form7 = this.fb.group({
    cities: new FormControl([], Validators.required),
  });

  form8 = this.fb.group({
    city: new FormControl<DictionaryDTO | null>(null),
  });

  formSelectNoFilter = this.fb.group({
    value: new FormControl<string | null>(null),
  });

  formSelectWithFilter = this.fb.group({
    value: new FormControl<string | null>(null),
  });

  formMultiNoFilter = this.fb.group({
    value: new FormControl<string[]>([]),
  });

  formMultiWithFilter = this.fb.group({
    value: new FormControl<string[]>([]),
  });
    
  selectErrorMessages = {
    required: 'Нужно обязательно выбрать хотя бы один город.',
  };



  constructor() {}

  handleAddSelect(): void {
    console.log('добавить нажата для селекта');
  }

  handleAddMultiSelect(): void {
    console.log('добавить нажата для мультиселекта');
  }

  citiesSuggestions: DictionaryDTO[] = [];

  handleCitySearch(event: AutoCompleteCompleteEvent): void {
    const query = (event.query || '').toLowerCase();
    this.citiesSuggestions = this.cities.filter((city) => {
      return (city.name || '').toLowerCase().includes(query);
    });
  }
}
